import styled from 'styled-components';

const HeaderStyle = styled.header`
	--headerPadTB: var(--sp4x);
	--headerPadLR: var(--sp4x);
	--headerLogoSize: var(--sp5x);

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	/* padding: var(--headerPadTB) var(--headerPadLR); */
	padding: var(--headerPadTB) var(--contPaddingLR);
	mix-blend-mode: difference;
	isolation: isolate;
	z-index: 7;
	transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
	will-change: transform;

	&.translate {
		transform: translateY(-100%);
	}

	/* //! Burger Active Styles */
	&.burger-active {
		transform: translateY(-100%) !important;
	}

	.header-inner-wrapper {
		display: grid;
		grid-template-columns: 1fr auto 1fr;
		align-items: center;
		align-self: stretch;
		gap: var(--sp3x);
	}

	.header-svg-block {
		display: flex;

		a {
			display: flex;
		}

		svg {
			height: var(--headerLogoSize);
		}
	}

	.right-block {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--headerPadTB: var(--sp4x);
		--headerPadLR: var(--sp4x);
		--headerLogoSize: var(--sp4x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--headerPadTB: var(--sp3x);
		--headerPadLR: var(--sp3x);
		--headerLogoSize: var(--sp4x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--headerPadTB: var(--sp3x);
		--headerPadLR: var(--sp3x);
		--headerLogoSize: var(--sp3-5x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--headerPadTB: var(--sp2x);
		--headerPadLR: var(--sp2x);
		--headerLogoSize: var(--sp3x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--headerPadTB: var(--sp2x);
		--headerPadLR: var(--sp2x);
		--headerLogoSize: var(--sp3x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--headerPadTB: var(--sp2x);
		--headerPadLR: var(--sp2x);
		--headerLogoSize: var(--sp2-5x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--headerPadTB: var(--sp1-5x);
		--headerPadLR: var(--sp1-5x);
		--headerLogoSize: var(--sp2-5x);

		.right-block {
			a {
				display: flex;
			}
		}

		.instagram-icon {
			font-size: var(--sp2x);
			color: var(--white1000);
		}
	}
`;

export default HeaderStyle;
